<script setup lang="ts">
import { computed } from 'vue';

import ModuleCarouselInteractionInstructionDisplay from '../ModuleCarouselInteractionInstructionDisplay/ModuleCarouselInteractionInstructionDisplay.vue';
import ModuleCarouselUserCustomDisplay from '../ModuleCarouselUserCustomDisplay/ModuleCarouselUserCustomDisplay.vue';

defineOptions({
  name: 'ModuleCarouselGroupDisplay'
});

interface CarouselInteractionComponents {
  title: { text?: string };
  cover: { backgroundColor?: string };
  stream: { backgroundSrc?: string; productSrc?: string };
}

interface CarouselUserCustomComponents {
  title: { text?: string };
  image1: { src?: string };
  image2: { src?: string };
  image3: { src?: string };
  image4: { src?: string };
  image5: { src?: string };
  image6: { src?: string };
}

interface Props {
  module: {
    components: {
      child?: {
        name?: string;
        components?: CarouselInteractionComponents | CarouselUserCustomComponents | any;
      };
    };
  };
}

const props = withDefaults(defineProps<Props>(), {
  module: () => ({
    components: {}
  })
});

const components = computed(() => props.module.components);

const isShowCarouselInteractionInstruction = computed(() => {
  return components.value.child?.name === 'CarouselInteractionInstruction';
});

const isShowCarouselUserCustom = computed(() => {
  return components.value.child?.name === 'CarouselUserCustom';
});

const carouselInteractionModule = computed((): { components: CarouselInteractionComponents } => {
  if (components.value.child?.components) {
    return components.value.child as { components: CarouselInteractionComponents };
  }
  return {
    components: {
      title: { text: '' },
      cover: { backgroundColor: '' },
      stream: { backgroundSrc: '', productSrc: '' }
    }
  };
});

const carouselUserCustomModule = computed((): { components: CarouselUserCustomComponents } => {
  if (components.value.child?.components) {
    return components.value.child as { components: CarouselUserCustomComponents };
  }
  return {
    components: {
      title: { text: '' },
      image1: { src: '' },
      image2: { src: '' },
      image3: { src: '' },
      image4: { src: '' },
      image5: { src: '' },
      image6: { src: '' }
    }
  };
});

</script>

<template>
<div class="module-carousel-group-display">
  <template v-if="isShowCarouselInteractionInstruction">
    <ModuleCarouselInteractionInstructionDisplay
      :module="carouselInteractionModule"
    />
  </template>
  <template v-else-if="isShowCarouselUserCustom">
    <ModuleCarouselUserCustomDisplay
      :module="carouselUserCustomModule"
    />
  </template>
</div>
</template>
